const r = ":host{display:block}.sl-sidebar{height:100%;background:hsl(var(--sl-hsl-card));color:hsl(var(--sl-hsl-foreground));overflow-y:auto;-webkit-overflow-scrolling:touch}.sl-sidebar--pinned{position:fixed;top:var(--sl-sidebar-top,3.5rem);left:0;bottom:0;width:var(--sl-sidebar-width,220px);border-right:1px solid hsl(var(--sl-hsl-border));padding-bottom:env(safe-area-inset-bottom,0)}.sl-sidebar--floating{position:relative;width:var(--sl-sidebar-width,220px);margin:var(--sl-sidebar-margin,1rem 0 1rem 1rem);border:1px solid hsl(var(--sl-hsl-border));border-radius:var(--sl-sidebar-radius,var(--sl-radius-lg))}@media (max-width:768px){.sl-sidebar--pinned{width:100%;max-width:280px;transform:translateX(-100%);transition:transform 0.2s ease;z-index:50}.sl-sidebar--pinned.sl-sidebar--open{transform:translateX(0)}}";
class i extends HTMLElement {
  static get observedAttributes() {
    return ["variant", "width", "top"];
  }
  constructor() {
    super(), this._shadow = this.attachShadow({ mode: "open" });
  }
  connectedCallback() {
    this._render();
  }
  disconnectedCallback() {
  }
  attributeChangedCallback(t, s, e) {
    s !== e && this._render();
  }
  get variant() {
    return this.getAttribute("variant") || "pinned";
  }
  set variant(t) {
    this.setAttribute("variant", t);
  }
  get width() {
    return this.getAttribute("width") || "220px";
  }
  set width(t) {
    this.setAttribute("width", t);
  }
  get top() {
    return this.getAttribute("top") || "3.5rem";
  }
  set top(t) {
    this.setAttribute("top", t);
  }
  _getClasses() {
    const t = ["sl-sidebar"];
    return t.push(`sl-sidebar--${this.variant}`), t.join(" ");
  }
  _render() {
    const t = `
      --sl-sidebar-width: ${this.width};
      --sl-sidebar-top: ${this.top};
    `;
    this._shadow.innerHTML = `
      <style>
        ${r}
        :host {
          ${t}
        }
      </style>
      <div class="${this._getClasses()}">
        <slot></slot>
      </div>
    `;
  }
}
typeof customElements < "u" && !customElements.get("sl-sidebar") && customElements.define("sl-sidebar", i);
export {
  i as SlSidebarElement
};
//# sourceMappingURL=sl-sidebar.js.map
